export default __webpack_public_path__ + "static/media/header.81b3b398.png";